// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__6sR4v","emails":"CreateEditClinics_emails__2k7CV","emailTagLabel":"CreateEditClinics_emailTagLabel__3X_Kx"};